export default "__VITE_ASSET__cc179ecd__"